import { render, staticRenderFns } from "./v4.vue?vue&type=template&id=0987e632&scoped=true&"
import script from "./v4.vue?vue&type=script&lang=js&"
export * from "./v4.vue?vue&type=script&lang=js&"
import style0 from "./v4.vue?vue&type=style&index=0&id=0987e632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987e632",
  null
  
)

export default component.exports